import { Component, OnInit } from '@angular/core';

import { AppSettings } from '../appSettings';

import { Subscription } from 'rxjs';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppFormat } from '../appFormat';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { SearchService } from '../services/search.service';
import { IUsersystem } from '../interfaces/usersystem';
import { OperadorService } from '../services/operador.service';
import { IPromotion } from '../interfaces/promotion';
import { PromotionService } from '../services/promotion.service';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.scss'],
  host: { class: 'wrapper-promotions' },
})
export class PromotionsComponent implements OnInit {
  public operador: IUsersystem;

  public num_todos: number = 0;
  public num_ativo: number = 0;
  public num_agendado: number = 0;
  public num_expirado: number = 0;

  public page: number = 1;
  public openid: number = null;

  public tab: string = 'ativo';

  public open: boolean = false;

  public promotions: IPromotion[];
  public promotion: IPromotion;

  public loadingPromotion: boolean = false;
  public loadingDetail: boolean = false;
  public loadingTab: boolean = false;

  public loadingDelete: boolean = false;
  public showConfirmDelete: boolean = false;
  public isDeletePromotion: boolean = false;

  public optionOpen: boolean = false;
  public optionTimeout: any = null;

  private query;

  public promotionFrm: FormGroup;

  public status: FormControl;

  public subscribeSearch: Subscription;

  public search: string = '';
  private timeoutSearch = null;

  public selector: string = '.wrapper-promotions';

  constructor(
    private _searchService: SearchService,
    private _promotionService: PromotionService,
    private _operadorService: OperadorService
  ) {
    this.query = { page: this.page };

    this.operador = this._operadorService.getOperador();

    this.subscribeSearch = this._searchService._searchPromotion.subscribe(
      (res) => {
        this.search = res;
        if (this.timeoutSearch) clearTimeout(this.timeoutSearch);

        this.timeoutSearch = setTimeout(() => {
          this.loadingTab = true;

          this.num_todos = 0;
          this.num_ativo = 0;

          this.closeDetail();
          this.changeTab(this.tab);
        }, 300);
      }
    );
  }

  ngOnInit(): void {
    this.promotions = [];
    this.promotion = {
      idpromocao: 0,
    };

    this.createFormControls();
    this.createForm();

    this.loadingTab = true;
    this.query['situacao'] = 'ativo';
    this.find();
  }

  ngOnDestroy(): void {
    this.subscribeSearch.unsubscribe();
  }

  createFormControls() {
    this.status = new FormControl('');
  }

  createForm() {
    this.promotionFrm = new FormGroup({
      status: this.status,
    });
  }

  showDeletePromotion() {
    this.isDeletePromotion = !this.isDeletePromotion;
    if (this.isDeletePromotion) {
      this.toggleOptions();
    }
  }

  onScroll() {
    if (!this.loadingPromotion) {
      this.page = this.page + 1;
      this.find();
    }
  }

  find() {
    this.loadingPromotion = true;

    this.query['page'] = this.page;

    if (this.search != '') {
      this.query['search'] = this.search;
    } else {
      if (this.query['search']) {
        delete this.query['search'];
      }
    }

    //str: string, sort: string, direction: string, page: number

    this._promotionService.search(this.query).subscribe((res) => {
      this.promotions =
        this.page > 1 ? this.promotions.concat(res.promotions) : res.promotions;

      if (res.num_todos) {
        this.num_todos = res.num_todos;
        this.num_agendado = res.num_agendado;
        this.num_expirado = res.num_expirado;
        this.num_ativo = res.num_ativo;
      }

      this.loadingPromotion = false;
      this.loadingTab = false;
    });
  }

  toggleOptions(): void {
    this.optionOpen = !this.optionOpen;

    this.clearOptions();
  }

  hideOptions(): void {
    if (this.optionOpen) {
      if (this.optionTimeout) clearTimeout(this.optionTimeout);

      this.optionTimeout = setTimeout(() => {
        this.optionOpen = false;
      }, 2000);
    }
  }

  clearOptions(): void {
    if (this.optionTimeout) clearTimeout(this.optionTimeout);
  }

  changeTab(tab): void {
    this.tab = tab;
    this.page = 1;

    this.loadingTab = true;

    delete this.query['situacao'];

    switch (tab) {
      case 'ativo':
        this.query['situacao'] = 'ativo';
        break;
      case 'agendado':
        this.query['situacao'] = 'agendado';
        break;
      case 'expirado':
        this.query['situacao'] = 'expirado';
    }

    this.find();
  }

  onDeletePromotion() {
    Swal.fire({
      title: 'Você realmente deseja excluir?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loadingDelete = true;
        this._promotionService
          .delete(this.promotion.idpromocao)
          .subscribe((res) => {
            if (res['success']) {
              this.showConfirmDelete = true;
              this.promotions.splice(this.openid, 1);
              switch (this.tab) {
                case 'ativo':
                  this.num_ativo = this.num_ativo - 1;
                  break;
                case 'agendado':
                  this.num_agendado = this.num_agendado - 1;
                  break;
                case 'expirado':
                  this.num_expirado = this.num_expirado - 1;
                  break;
              }
              this.num_todos = this.num_todos - 1;
              setTimeout(() => {
                this.closeDetail();
              }, 500);
            } else {
              Swal.fire('Ops!', 'Ocorreu um erro ao tentar excluir.', 'error');
            }
            this.loadingDelete = false;
          });
      }
    });
  }

  openDetail(promotion: IPromotion, i: number) {
    document.getElementById('detailPromotion').scrollTop = 0;

    this.showConfirmDelete = false;
    this.isDeletePromotion = false;
    this.open = true;

    this.promotion = promotion;

    this.status.setValue(promotion.status == 'A' ? true : false);

    this.openid = i;
  }

  closeDetail() {
    this.open = false;
    this.openid = null;
  }

  onSubmit() {
    if (this.promotionFrm.valid) {
    }
    return false;
  }

  updateStatus() {
    this.promotion.status = this.status.value ? 'A' : 'I';

    this._promotionService
      .patch(this.promotion.idpromocao, {
        status: this.status.value ? 'A' : 'I',
      })
      .subscribe((res) => {});
  }
}
